import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "arrow-split, rules, direction, split" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M2.3335 6.33398V2.33398M2.3335 2.33398H6.3335M2.3335 2.33398L8.00016 8.00065M9.66683 2.33398H13.6668M13.6668 2.33398V6.33398M13.6668 2.33398L8.00016 8.00065M8.00016 8.00065V13.6673",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }